import { render, staticRenderFns } from "./Staff01.vue?vue&type=template&id=aa89afb8&scoped=true&"
import script from "./Staff01.vue?vue&type=script&lang=js&"
export * from "./Staff01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa89afb8",
  null
  
)

export default component.exports